import { GroupedNotificationsRequest, NotificationTypeOverride } from '../models/notifications-grouped.model';

export const NOTIFICATIONS_LOCALIZATION_SCOPE = 'notifications-drawer';

export const NOTIFICATION_TYPE_LABEL_KEYS: Record<string, string> = {
  activity: 'activity',
  'ownership-criteria': 'ownershipCriteria',
  reporting: 'reporting'
};

export const DEFAULT_WITHIN_DAYS = 7;

export const DEFAULT_LIMIT_PER_TYPE = 3;

export interface NotificationTypeConfig {
  notificationTypeId: number;
  withinDays: number;
  initialLimit: number;
  loadMoreLimit?: number;
}

export const NOTIFICATION_TYPE_CONFIGS: Record<string, NotificationTypeConfig> = {
  activity: { notificationTypeId: 1, withinDays: 7, initialLimit: 3, loadMoreLimit: 20 },
  'ownership-criteria': { notificationTypeId: 2, withinDays: 7, initialLimit: 3 },
  reporting: { notificationTypeId: 3, withinDays: 30, initialLimit: 5 }
};

export function buildGroupedNotificationListRequest(
  typeCurrentLimits: Record<string, number>
): GroupedNotificationsRequest {
  const overrides: Record<string, NotificationTypeOverride> = {};

  for (const [code, config] of Object.entries(NOTIFICATION_TYPE_CONFIGS)) {
    overrides[code] = {
      notificationTypeId: config.notificationTypeId,
      withinDays: config.withinDays,
      limitPerType: typeCurrentLimits[code] ?? config.initialLimit
    };
  }

  return {
    defaultWithinDays: DEFAULT_WITHIN_DAYS,
    defaultLimitPerType: DEFAULT_LIMIT_PER_TYPE,
    notificationTypeOverrides: overrides
  };
}
